import { createContext } from "react";
import { Channel, Socket } from "phoenix";

import {
  BulkReceiptSentResponse,
  ChatMessage,
} from "@web-src/modules/chats/types";
import { Subject } from "rxjs";

export type PhoenixSocketContextType = {
  socket?: Socket;
  channel?: Channel;
  incomingMessages$?: Subject<ChatMessage>;
  indicatorMessages$?: Subject<{ message: ChatMessage; merge: boolean }>;
  receiptSent$?: Subject<BulkReceiptSentResponse>;
  socketConnected: boolean;
  conversationMessages$?: Subject<{
    type: "phx_mark_conversation_sent" | "phx_clear_mention_sent";
    payload: { chat_id: string; unread?: boolean };
  }>;
};

export const PhoenixSocketContext = createContext<PhoenixSocketContextType>({
  socket: undefined,
  channel: undefined,
  incomingMessages$: undefined,
  indicatorMessages$: undefined,
  socketConnected: false,
});
